<template>
  <com-header>
    <div class="invitation">
      <ul>
        <li>8000个品牌SKU工厂直供</li>
        <li>10个子账户</li>
        <li>全国无忧服务</li>
        <li>一站式一键购买服务</li>
      </ul>
      <div class="footer">
        <van-button block native-type="button" @click="onClick">立即免费开通使用</van-button>
      </div>
    </div>
  </com-header>
</template>

<script>
import ComHeader from "./components/comHeader";
import { Button } from "vant";
export default {
  metaInfo: { title: "vip会员权限开通" },
  components: {
    ComHeader,
    [Button.name]: Button,
  },
  methods: {
    onClick() {
      this.$router.push({
        name: "collect",
        params: { id: this.$route.params.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.invitation {
  background: url("~@/assets/img/settlement1.jpg") no-repeat fixed center;
  background-size: 100%;
  background-color: #222222;
  min-height: 100vh;
  padding: 6rem 0.3rem 0.3rem;
  box-sizing: border-box;
  ul {
    height: 4rem;
    padding: 0.6rem;
    box-sizing: border-box;
    border-radius: 6px;
    background: #dab8a5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    &::after {
      display: block;
      content: "";
      position: absolute;
      left: 1.2rem;
      top: -16px;
      width: 0;
      height: 0;
      border-width: 8px;
      border-style: solid;
      border-color: transparent transparent #dab8a5 transparent;
    }
    li {
      font-size: 14px;
      padding-left: 0.36rem;
      line-height: 20px;
      position: relative;
      &::after {
        display: block;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 2px;
        height: 18px;
        background: #5d271b;
        border: 1px solid #734133;
      }
    }
  }
  .footer {
    margin-top: 1.4rem;
    box-sizing: border-box;
    .van-button {
      background: linear-gradient(90deg, #af5844, #6f3629);
      border: none;
      color: #ffffff;
      font-size: 18px;
      border-radius: 15px;
    }
  }
}
</style>